import { GridApi, GridOptions } from "ag-grid-community";
import { Injectable } from "@angular/core";
import { IServerSideRequestOptions } from "../data-source.interfaces";
import { BsshDataTableApiService } from "./bssh-data-table-api-service.service";
import { Observable } from "rxjs";
import { ToastrService } from "@bssh/comp-lib";
import {
  buildCacheConfigErrorMessage,
  isServerSideCacheConfigValid,
  shouldValidateServerSideCache,
} from "../server-side-cache.utils";

@Injectable()
export class BsshDataTableServerSideDatasourceService {
  apiDriver: BsshDataTableApiService;
  gridInstance: GridApi;
  requestOptions: IServerSideRequestOptions;
  gridOptions: GridOptions;

  private cacheErrorLogged = false;
  private cacheErrorToastShown = false;

  constructor(private toastrService: ToastrService) { }

  init(
    initOptions: {
      apiDriver: BsshDataTableApiService;
      gridInstance: GridApi;
      requestOptions?: IServerSideRequestOptions,
      gridOptions?: GridOptions,
      initialQuery?: Observable<any>;
    }
  ) {
    const { apiDriver, gridInstance, requestOptions, gridOptions } = initOptions;

    this.apiDriver = apiDriver;
    this.gridInstance = gridInstance;
    this.requestOptions = requestOptions;
    this.gridOptions = gridOptions;
    this.cacheErrorLogged = false;
    this.cacheErrorToastShown = false;

    this.gridInstance.setServerSideDatasource(this);
  }

  getRows(params: any) {
    if (this.isCacheConfigInvalid()) {
      params.failCallback();
      return this;
    }

    this.apiDriver.getData(this.requestOptions, params.request, this.gridInstance)
      .subscribe((data: any) => {
        if (Array.isArray(data.rowData)) {
          params.successCallback(data.rowData, data.lastRow);
        }
      }, (error) => {
        params.failCallback(error);
      });

    return this;
  }

  private isCacheConfigInvalid(): boolean {
    if (!this.gridOptions || !this.gridInstance || !shouldValidateServerSideCache(this.gridOptions)) {
      return false;
    }

    const cacheBlockSize = this.gridOptions.cacheBlockSize;
    if (!cacheBlockSize) {
      return false;
    }

    const config = {
      paginationPageSize: this.gridInstance.paginationGetPageSize(),
      cacheBlockSize,
      maxBlocksInCache: this.gridOptions.maxBlocksInCache,
    };

    if (isServerSideCacheConfigValid(config)) {
      this.cacheErrorLogged = false;
      this.cacheErrorToastShown = false;
      return false;
    }

    const errorMessage = buildCacheConfigErrorMessage(config);

    if (!this.cacheErrorLogged) {
      console.error(errorMessage);
      this.cacheErrorLogged = true;
    }

    if (!this.cacheErrorToastShown) {
      this.toastrService.error(errorMessage, 'Error loading table');
      this.cacheErrorToastShown = true;
    }

    return true;
  }
}
